<template>
  <div class="Layout">
    <router-view></router-view>
    <tabbar></tabbar>
  </div>
</template>
<script>
import {showToast} from "@/libs/util.js";

import Web3 from "web3";
import {ajaxData} from "@/api/ajax";
import {setToken, getToken} from "@/libs/util";
import InvestAbi from "@/abi/Invest-abi.json";
import tabbar from "@/view/components/tabbar.vue";

export default {
  components: {
    tabbar,
  },
  data() {
    return {
      index: 1,
      invite: "0x0000000000000000000000000000000000000000",
      nft: [],
      address: "",
      gmc_balance: "0",
      gmc_balance_about: "0",
      gmc_price: 0,
      notice: "",
      rotation: [],
      synopsis: "",
      show_address: "",
      web3Provider: null,
      web3: null,
      homepopup_rule: "",
      homepopup_title: "",
    };
  },
  created(options) {
  },
  methods: {
    async isCheckUser(address) {
      let res = await ajaxData("/check", {
        address,
      });
      return res.data?.result;
    },
    enable() {
      let vm = this;
      if (sessionStorage.getItem("isLagout")) return;
      if (window.ethereum) {
        vm.web3Provider = window.ethereum;
        vm.web3 = new Web3(vm.web3Provider);
        vm.address = vm.web3Provider.selectedAddress;
        // this.invite_contract();
        // let token = getToken()
        // token = false
        // if (token == false){
        // }else{
        //     vm.getUser()
        //     console.log(token)
        // }
      }
      let isRegister = vm.isCheckUser(vm.address);
      // if (!isRegister) {
      this.invite_contract();
      // }
      vm.web3Provider
          .enable() //如果用户拒绝了登录请求
          .catch(function (reason) {
            console.log("reason");
            if (reason === "User rejected provider access") {
              showToast("用户拒绝提供程序访问");
            } else {
              // 本不该执行到这里，但是真到这里了，说明发生了意外
              showToast("请刷新重试");
            }
          })
          //如果用户同意了登录请求，你就可以拿到用户的账号
          .then(function (accounts) {
            console.log("-----");
            // alert(ethereum.selectedAddress)
            // You also should verify the user is on the correct network:
            //你也可以验证用户接入了正确的网络
            if (vm.web3Provider.networkVersion !== vm.desiredNetwork) {
              // layer_msg('请选择正确的网络.')
              //我们计划在最近补充一个有关网络切换的API，参考下面链接
              // https://github.com/MetaMask/metamask-extension/issues/3663
            }
            //一旦获取了用户账号，你就可以签名交易
            console.log(accounts);

            vm.address = vm.web3Provider.selectedAddress;
            vm.address = vm.address.toLowerCase();
            let toastStr = `Welcome to Galmcypro, start explore right now！Click "Sign" to sign in.  No password needed！

Wallet address:
${vm.address}`;
            // let toastStr = "login";
            console.log("selectaddress:" + vm.address);
            let token = getToken();
            if (token == false) {
              console.log(1111111111111);
              vm.web3.eth.personal.sign(
                  vm.web3.utils.utf8ToHex(toastStr),
                  vm.address,
                  (err, sign) => {
                    console.log(err, sign);
                    if (err) {
                      console.log("111", err);
                      showToast(err);
                    } else {
                      console.log(vm.address, vm.invite);
                      ajaxData("/register", {
                        address: vm.address,
                        invite: vm.invite,
                      }).then((response) => {
                        console.log(response);
                        setToken(response.data.token);
                        vm.getUser();
                      });
                      // }else {
                      //     vm.getUser()
                      // }
                    }
                  }
              );
            } else {
              vm.getUser();
            }
          });
    },
    enableLogin() {
      let vm = this;
      if (window.ethereum) {
        vm.web3Provider = window.ethereum;
        vm.web3 = new Web3(vm.web3Provider);
        // vm.address = vm.web3Provider.selectedAddress;

        // let token = getToken()
        // token = false
        // if (token == false){
        // }else{
        //     vm.getUser()
        //     console.log(token)
        // }
      }
      vm.web3Provider
          .enable() //如果用户拒绝了登录请求
          .catch(function (reason) {
            console.log("reason");
            if (reason === "User rejected provider access") {
              showToast("用户拒绝提供程序访问");
            } else {
              // 本不该执行到这里，但是真到这里了，说明发生了意外
              showToast("请刷新重试");
            }
          })
          //如果用户同意了登录请求，你就可以拿到用户的账号
          .then(function (accounts) {
            console.log("-----");
            // alert(ethereum.selectedAddress)
            // You also should verify the user is on the correct network:
            //你也可以验证用户接入了正确的网络
            if (vm.web3Provider.networkVersion !== vm.desiredNetwork) {
              // layer_msg('请选择正确的网络.')
              //我们计划在最近补充一个有关网络切换的API，参考下面链接
              // https://github.com/MetaMask/metamask-extension/issues/3663
            }
            //一旦获取了用户账号，你就可以签名交易
            console.log(accounts);

            vm.address = vm.web3Provider.selectedAddress;
            vm.address = vm.address.toLowerCase();
            let toastStr = `Welcome to Galmcypro, start explore right now！Click "Sign" to sign in.  No password needed！

Wallet address:
${vm.address}`;
            // let toastStr = "login";
            console.log("selectaddress:" + vm.address);

            console.log(1111111111111);
            vm.web3.eth.personal.sign(
                vm.web3.utils.utf8ToHex(toastStr),
                vm.address,
                (err, sign) => {
                  console.log(err, sign);
                  if (err) {
                    console.log("111", err);
                    showToast(err);
                  } else {
                    console.log(vm.address, vm.invite);
                    ajaxData("/register", {
                      address: vm.address,
                      invite: vm.invite,
                    }).then((response) => {
                      console.log(response);
                      setToken(response.data.token);
                      vm.getUser();
                    });
                    // }else {
                    //     vm.getUser()
                    // }
                  }
                }
            );
          });
    },
    childhome(e) {
      console.log("调用");
      this.index = e;
    },
    notOpen() {
      showToast(this.$t('no_open'));
    },
    updateIndex(index) {
      this.index = index;
    },
    setting() {
      let vm = this;
      ajaxData("/setting", {}).then((response) => {
        vm.approve_address = response.data.data.setting.general_address;
        vm.notice = response.data.data.setting.notice;
        vm.synopsis = response.data.data.setting.synopsis;
        vm.rotation = response.data.data.rotation;

        console.log("*****");
        console.log(vm.rotation);
      });
    },
    getNotice() {
      let vm = this;
      ajaxData("/setting", {key: "homepopup"}).then((response) => {
        if (localStorage.getItem("locale") == "zh") {
          vm.homepopup_rule = response.data.setting.rule;
          vm.homepopup_title = response.data.setting.title;
        } else {
          vm.homepopup_rule = response.data.setting.rule_en;
          vm.homepopup_title = response.data.setting.title_en;
        }
      });
    },
    getNft() {
      let vm = this;
      ajaxData("/nft", {}).then((response) => {
        response.data?.nft.forEach((val) => {
          if (localStorage.getItem("locale") == "en") {
            val.name = val.name_en;
            val.content = val.content_en;
            val.synopsis = val.synopsis_en;
          }
          vm.nft.push(val);
        });
      });
    },
    getUser() {
      let vm = this;
      ajaxData("/user/info", {}).then((response) => {
        let user = response.data.user;
        vm.gmc_price = parseFloat(response.data.gmc_price);
        vm.gmc_balance = response.data.gmc_balance;
        vm.gmc_balance_about = response.data.gmc_balance_about;
        // vm.show_address = user.show_address;
        vm.crowd_funding = user.crowd_funding;
        vm.crowd_funding = user.crowd_funding;

        if (user.address != vm.address) {
          setToken("");
          vm.enable();
        }
        console.log(user.address);
        console.log(vm.address);
      });
    },
    // 注册业务
    async invite_contract() {
      let vm = this;
      let invite_contract_address =
          "0x58625C8F01e66445c23cB242EB343583Af7a447a";
      let contract = new vm.web3.eth.Contract(
          InvestAbi,
          invite_contract_address
      );
      // vm.invite = '0x8708b44673088871b8A03A81Af1f999ba0e0fF1b';
      console.log("contract address", contract);
      try {
        let invite_result = await contract.methods
            .bindIntro(vm.invite)
            .call();
        console.log("result", invite_result);
        if (invite_result) {
          ajaxData("/register", {
            address: vm.address,
            invite: vm.invite,
          }).then((response) => {
            console.log(response);
            setToken(response.data.token);
            vm.getUser();
          });
        }
      } catch (e) {
        console.error("错误内容:", e);
      }
    },
    subAddress(val) {
      console.log(val);
      let address = "";
      try {
        if (val != "") {
          address =
              val.substr(0, 12) +
              `*****` +
              val.substr(val.length - 12, 12);
        }
      } catch (e) {
      }
      return address;
    },
  },
};
</script>
<style scoped lang="less">
p {
  margin: 0;
  padding: 0;
}

.home {
  width: 100%;
  background: #f9f9f9;
}

.kaifa {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-top: 50%;
  color: #333;
  font-weight: bold;
}

.popviewnew {
  width: 100%;
  position: relative;
  height: 330px;
}
</style>
  